
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
    name: 'interview-table',
    components: {
    }
})
export default class CompanyTable extends Vue {
    @Prop({ required: true }) private value!: any[]
}
